import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    SelectInput,
    FunctionField,
} from "react-admin";
import { Box } from "@mui/material";
import StatusField from "../../components/StatusField";
import ResourceStatusHeader from "../../components/ResourceStatusHeader";
import ValidateButton from "./ValidateButton";
import RejectButton from "./RejectButton";
import { useResourceSearchFilter } from "../../hooks/useResourceSearch";

const OobjectVariantFilters = [
    <SelectInput
        key="status"
        source="status"
        label="Statut"
        alwaysOn
        choices={[
            { id: "PENDING", name: "PENDING" },
            { id: "VALIDATED", name: "VALIDATED" },
            { id: "REJECTED", name: "REJECTED" },
        ]}
    />,
];

const getVariantLabel = (record) =>
    record?.variantLabel ||
    record?.label ||
    record?.value ||
    record?.variant?.value ||
    record?.shortOobject ||
    "—";

const getOobjectAuthor = (record) =>
    record?.oobjectCreatedByUsername ||
    record?.oobjectUsername ||
    record?.oobject?.username ||
    "—";

const getVariantAuthor = (record) =>
    record?.createdByUsername ||
    record?.variantAuthor ||
    record?.createdBy ||
    "—";

export default function OobjectVariantList() {
    const searchFilter = useResourceSearchFilter("oobject-variants");

    return (
        <>
            <ResourceStatusHeader
                resource="oobject-variants"
                title="Variantes d'oobject"
                subtitle="Totaux par statut"
            />
            <List
                exporter={false}
                perPage={25}
                sort={{ field: "createdAt", order: "DESC" }}
                filters={OobjectVariantFilters}
                filter={searchFilter}
                title="Oobject Variants"
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="id" label="ID" />
                    <TextField source="oobjectId" label="Oobject UUID" />
                    <TextField source="oobject" label="Oobject" />
                    <FunctionField label="Variante" render={getVariantLabel} />
                    <FunctionField label="Auteur oobject" render={getOobjectAuthor} />
                    <FunctionField label="Auteur variante" render={getVariantAuthor} />
                    <StatusField source="status" label="Statut" />
                    <DateField source="createdAt" label="Créé le" showTime />
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                        <ValidateButton />
                        <RejectButton />
                    </Box>
                </Datagrid>
            </List>
        </>
    );
}
